import React from 'react';

const SmallToggle = ({ options, selected, onChange }) => {
  if (!options || options.length !== 2) return null;

  return (
    <div className="flex items-center justify-center ">
      <div className="flex bg-grayExtraLight2 rounded-full w-full h-6">
        {options.map((option, index) => (
          <button
            key={option}
            onClick={() => onChange(option)}
            style={{ fontSize: '11px' }}
            className={`flex-1 font-semibold tracking-wider transition-colors px-3 duration-300 uppercase
              ${index === 0 ? 'rounded-l-full' : 'rounded-r-full'}
              ${selected === option ? 'bg-tealExtraLight3 text-white' : 'bg-transparent text-grayExtraLight3'}
            `}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SmallToggle;
